import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import FoodMenu from './section-components/FoodMenu';
import Footer from './global-components/footer';

const MainMenu = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Masala Hut"  />
        <FoodMenu />
        <Footer />
        
    </div>
}

export default MainMenu

